import React from "react";
import {useDispatch, useSelector} from "react-redux";
import * as _ from 'lodash';
import {useNavigate, useSearchParams} from "react-router-dom";
import {authenticationActions} from "../../../actions/index";
import fascia_loghi from "../../../assets/img/fascia_loghi.png";
import { isPwa } from "../../../fanctionUtility";
import qr_code_staging from "../../../assets/img/qr-rec-staging.png";
import qr_code_prod from "../../../assets/img/qr-rec-prod.png";

const qr_code = (window.location.hostname.startsWith('test') || window.location.hostname.includes('localhost'))
    ?qr_code_staging:qr_code_prod;
const Login = () => {
    const navigate = useNavigate();
    const configurationFile = useSelector(state => state.configurationFile.fileConf);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const authenticationStart = React.useCallback((clientId, baseUrlAuthService, redirectUri, navigate) => dispatch(authenticationActions.authenticationStart(clientId, baseUrlAuthService, redirectUri, navigate)), [dispatch]);
    const authenticationContinue = React.useCallback((clientId, baseUrlAuthService, code, redirectUri, navigate) => dispatch(authenticationActions.richiediToken(clientId, baseUrlAuthService, code, redirectUri, navigate)), [dispatch]);

        React.useEffect(() => {
        sessionStorage.clear();
        window.scrollTo(0, 0);

        if (searchParams.get('disabilitato') === 'true') {
            dispatch({
                type: 'NOTIF_SEND',
                payload: {type: 'danger', message: "Il tuo account è stato disabilitato. Contatta l'amministratore di sistema.", dismissAfter: 15000}
            });
            setSearchParams({}, {replace: true});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const authentication = () => {
        if (configurationFile != null && !_.isEmpty(configurationFile)) {
            authenticationStart(
                configurationFile.clientId,
                configurationFile.baseUrlAuthService,
                configurationFile.redirectUri,
                navigate
            );
        }
    };

    React.useMemo(() => {        
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        if (params.has('code')) {
            const code = params.get('code');
            const newUrl = window.location.origin + window.location.pathname;
            window.history.replaceState(null, '', newUrl);
            setTimeout(() => {
                authenticationContinue(
                    configurationFile.clientId,
                    configurationFile.baseUrlAuthService,
                    code,
                    configurationFile.redirectUri,
                    navigate);
            }, 250)
        }
      }, []);

    return (
        <div data-test="component-login">
            {isPwa() && (<img className="w-100" alt="Fascia Loghi" src={fascia_loghi}/>)}
            <div className="row w-100 m-0">
                <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div className="card card-signin my-5 animate__animated animate__fadeIn shadowCustom"
                         style={{borderRadius: '30px'}}>
                        <div className="card-body">
                            <h3 className='card-title text-center'>Accesso Applicativo</h3>
                            <p className="text-muted text-center">
                                Verifica profili
                            </p>
                            <div className="d-flex justify-content-center">
                                <button className="px-4 btn btn-primary shadow"
                                        id='accediButton'
                                        onClick={() => authentication()}>
                                    <i className="fa fa-sign-in mr-2"/>
                                    Accedi
                                </button>
                            </div><br/><br/>
                            <p className="text-muted text-center">
                                Inquadra il QRcode con il tuo smartphone per accedere a REC via mobile
                            </p>
                            <div className="d-flex justify-content-center">
                                <img className="justify-content-center"  alt="QR Code" src={qr_code}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;

